import React, { useState, useContext } from "react";
import MyAttendanceHead from "../../../../components/Attendance/ManageAttendance/MyAttendanceHead";
import MyAttendanceTable from "../../../../components/Attendance/AttendanceList/MyAttendanceTable";
import AttendanceMiniOverview from "../../../../components/Attendance/SelfService/MyAttendance/AttendanceMiniOverview/AttendanceMiniOverview";
import MyAttendanceCalendarView from "../../../../components/Attendance/SelfService/MyAttendance/MyAttendanceCalendarView/MyAttendanceCalendarView";
import { ATTENDANCE_ACTIVITY_VIEW } from "../../../../redux/constants/actvityType";
import moment from "moment";
const TABLE_VIEW = ATTENDANCE_ACTIVITY_VIEW.TABLE_VIEW;


const MyAttendance = () => {

  const [dataView, setDataView] = useState(TABLE_VIEW);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedLabel, setSelectedLabel] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState({
    value: "",
    label: "All Status",
  });
 const [fromDate, setFromDate] = useState(moment().startOf("month").toDate());

  const [toDate, setToDate] = useState(moment().toDate()); 


  const handleSetView = (e) => {
    setDataView(e);
  };

  const handleSelectedOptionChange = (selected) => {
    setSelectedOption(selected);
    setSelectedLabel(selected);
  };

  const handleStatusChange = (selected) => {
    setSelectedStatus(selected);
  };

  const handleDateChange = (newFromDate, newToDate) => {
    setFromDate(newFromDate);
    setToDate(newToDate);
  };

  return (
    <div className="flex flex-1">
      <div className="flex-1 flex-col">
        <div className="relative mb-20">
          <MyAttendanceHead
            handleSetView={handleSetView}
            dataView={dataView}
            selectedOption={selectedOption}
            onSelectedOptionChange={handleSelectedOptionChange}
            setSelectedOption={setSelectedOption}
            setSelectedLabel={setSelectedLabel}
            fromDate={fromDate}
            setFromDate={setFromDate}
            toDate={toDate}
            setToDate={setToDate}
            selectedStatus={selectedStatus}
            onStatusChange={handleStatusChange}
            onDateChange={handleDateChange}
            showRegularizationPanel={true} 
            showClockData={true}
           
          />

          {dataView === TABLE_VIEW ? (
            <MyAttendanceTable
              selectedOption={selectedOption}
              label={selectedStatus}
              fromDate={fromDate}
              toDate={toDate}
            
            />
          ) : (
            <MyAttendanceCalendarView
              selectedOption={selectedOption}
              label={selectedStatus}
              fromDate={fromDate}
              toDate={toDate}
            />
          )}
        </div>
        <div className="fixed w-5/6 bottom-0">
          <AttendanceMiniOverview fromDate={fromDate} toDate={toDate} />
        </div>
      </div>
    </div>
  );
};

export default MyAttendance;
